// src/components/button/button.styles.ts
import { tv } from "tailwind-variants";
var buttonStyles = tv({
  base: "flex justify-center items-center rounded-full font-bold border border-transparent focus:outline-none focus-visible:ring-4 focus-visible:ring-focus transition disabled:cursor-not-allowed",
  variants: {
    variant: {
      primary: (
        // Must have min font size of 20px to maintain accessibility
        "!text-xl bg-primary text-primary-fg fill-primary-fg hover:bg-primary-int active:bg-primary-int"
      ),
      secondary: "bg-secondary text-secondary-fg fill-secondary-fg hover:bg-secondary-int active:bg-secondary-int",
      /**
       * @deprecated Use `secondary` instead.
       */
      default: "bg-secondary text-secondary-fg fill-secondary-fg hover:bg-secondary-int active:bg-secondary-int",
      outline: "text-secondary bg-secondary-fg border-secondary fill-secondary hover:text-secondary-fg hover:bg-secondary-int hover:border-secondary-int hover:fill-secondary-fg active:text-secondary-fg active:bg-secondary-int active:border-secondary-int active:fill-secondary-fg",
      outlineDashed: "fill-secondary border-dashed border-secondary bg-secondary-fg text-secondary hover:text-secondary-int hover:fill-secondary-int",
      outlineReversed: "text-neutral-0 bg-secondary border-secondary fill-neutral-0 hover:text-secondary hover:bg-neutral-0 hover:border-secondary hover:fill-secondary active:text-secondary active:bg-neutral-0 active:border-secondary active:fill-secondary",
      unstyled: "border border-transparent bg-transparent rounded-none"
    },
    size: {
      sm: {
        base: "py-1 px-4 min-h-10"
      },
      md: {
        base: "py-2 px-4 min-h-12"
      },
      lg: {
        base: "py-3 px-4 min-h-14"
      }
    },
    iconOnly: {
      true: "rounded-full",
      false: {
        loadingContainer: "pr-1",
        contentStartWrapper: "pr-1",
        contentEndWrapper: "pl-1"
      }
    }
  },
  slots: {
    loadingContainer: "",
    contentStartWrapper: "",
    contentEndWrapper: ""
  },
  compoundVariants: [
    {
      iconOnly: true,
      size: "sm",
      className: "w-8 h-8 min-h-8 p-1"
    },
    {
      iconOnly: true,
      size: "md",
      className: "w-10 h-10 min-h-10 p-1"
    },
    {
      iconOnly: true,
      size: "lg",
      className: "w-12 h-12 min-h-12 p-1"
    },
    {
      variant: ["primary", "default", "outline"],
      className: "disabled:bg-neutral-400"
    }
  ],
  compoundSlots: [
    {
      slots: ["loadingContainer", "contentStartWrapper", "contentEndWrapper"],
      size: ["sm", "md", "lg"],
      className: "[&>svg]:w-6 [&>svg]:h-6"
    }
  ],
  defaultVariants: {
    iconOnly: false
  }
});
export {
  buttonStyles
};
